<script>
import { isUserLoggedIn, signTheUserOut } from "@/services/UserServices";
import logo from '@/assets/logo-sm.png';

export default {
  computed: {
    isAuthenticated() {
      return isUserLoggedIn();
    },
    homeOrDash() {
      return this.isAuthenticated ? '/dash' : '/';
    },
  },
  props: [
    'dayOfWeek',
    'todaysDateDisplay'
  ],
  data() {
    return {
      logo,
      drawer: false,
    };
  },
  methods: {
    async signOut() {
      await signTheUserOut();
      this.$router.push('/');
    }
  }
}
</script>

<template>
  <div class="bg-black text-white text-right py-9 pr-8">
    <ul>
      <li><router-link to="/faq">FAQs</router-link></li>
      <li><router-link to="/about">About</router-link></li>
      <li><router-link to="/faq#contact-form">Contact</router-link></li>
    </ul>
  </div>
</template>

<style lang="scss" scoped>
ul {
  list-style: none;
  li {
    margin-bottom: 6px;
    a {
      color: lightgray;
      font-size: 13px;
      text-decoration: none;
      &:hover { text-decoration: underline; }
    }
  }
}
</style>
